import request from '@/utils/request'

// 查询监控分页
export function pageMonitor(data) {
  return request({
    url: '/cloudplant/monitor/page',
    method: 'post',
    data: data
  })
}

// 查询监控列表
export function listMonitor(query) {
  return request({
    url: '/cloudplant/monitor/list',
    method: 'get',
    params: query
  })
}

// 查询监控详情
export function getMonitor(data) {
  return request({
    url: '/cloudplant/monitor/detail',
    method: 'get',
    params: data
  })
}

// 新增监控
export function addMonitor(data) {
  return request({
    url: '/cloudplant/monitor/add',
    method: 'post',
    data: data
  })
}

// 修改监控
export function updateMonitor(data) {
  return request({
    url: '/cloudplant/monitor/edit',
    method: 'post',
    data: data
  })
}

// 删除监控
export function delMonitor(data) {
  return request({
    url: '/cloudplant/monitor/delete',
    method: 'post',
    data: data
  })
}
